import React from 'react';
import './style.css';

export default function Logo() {
  return (
    <div className="d-flex flex-column align-items-center logo-container">
      <div className="logo-safe">Super safe</div>
      <div className="logo-sale">Super offer</div>
      <div className="logo-review">Reviews&nbsp;
        <i className="fa fa-star text-warning" aria-hidden="true"></i>&nbsp;
        <i className="fa fa-star text-warning" aria-hidden="true"></i>&nbsp;
        <i className="fa fa-star text-warning" aria-hidden="true"></i>&nbsp;
        <i className="fa fa-star text-warning" aria-hidden="true"></i>&nbsp;
        <i className="fa fa-star text-warning" aria-hidden="true"></i>&nbsp;
      </div>
    </div>
  );
}